import { definePropType } from '@types-vue/props'
import type { TranslateResult } from 'vue-i18n'
import type { ExtractPropTypes } from 'vue'

export const selectProps = {
  name: String,
  id: String,
  value: {
    required: true,
  },
  autocomplete: {
    type: String,
    default: 'off',
  },
  /** @Deprecated in next major version */
  autoComplete: {
    type: String,
    validator(val: any) {
      process.env.NODE_ENV !== 'production' &&
        console.warn(
          "[Element Warn][Select]'auto-complete' property will be deprecated in next major version. please use 'autocomplete' instead.",
        )
      return true
    },
  },
  automaticDropdown: Boolean,
  size: String,
  disabled: Boolean,
  clearable: Boolean,
  filterable: Boolean,
  allowCreate: Boolean,
  loading: Boolean,
  popperClass: String,
  remote: Boolean,
  loadingText: String,
  noMatchText: String,
  noDataText: String,
  remoteMethod: Function,
  filterMethod: Function,
  multiple: Boolean,
  multipleLimit: {
    type: Number,
    default: 0,
  },
  placeholder: {
    type: String,
    required: false,
  },
  defaultFirstOption: Boolean,
  reserveKeyword: Boolean,
  valueKey: {
    type: String,
    default: 'value',
  },
  collapseTags: Boolean,
  popperAppendToBody: {
    type: Boolean,
    default: true,
  },
  preLabel: {
    type: definePropType<TranslateResult>([String, Object]),
  },
  autoWidth: {
    type: Boolean,
    default: false,
  },
  ghost: {
    type: Boolean,
    default: false,
  },
  mini: {
    type: Boolean,
    default: false,
  },
} as const

export type SelectProps = ExtractPropTypes<typeof selectProps>

export const optionProps = {
  value: {
    required: true,
  },
  label: [String, Number],
  description: String,
  tips: String,
  created: Boolean,
  disabled: Boolean,
} as const

export type OptionProps = ExtractPropTypes<typeof optionProps>

export const optionGroupProps = {
  label: String,
  disabled: Boolean,
} as const

export type OptionGroupProps = ExtractPropTypes<typeof optionGroupProps>

export const selectProProps = {
  ...selectProps,
  // checkable: Boolean,

  options: {
    type: definePropType<OptionProps[]>(Array),
    required: true,
  },
} as const

export type SelectProProps = ExtractPropTypes<typeof selectProProps>

export interface OptionGroupProProps extends OptionGroupProps {
  options: OptionProps[]
}

export const selectGroupProProps = {
  ...selectProps,
  // checkable: Boolean,

  options: {
    type: definePropType<OptionGroupProProps[]>(Array),
    required: true,
  },
} as const
